import React from 'react';

import { CustomSVGProps } from '@cineamo/ui/src/icons/CustomSVGProps.types';

export function IconGooglePlayColored24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Google Play">
            <path
                d="M1.37294 0.328964C1.09323 0.60867 1 1.07485 1 1.63426V22.2392C1 22.7986 1.18647 23.2648 1.46618 23.5445L1.55941 23.6378L13.1206 12.0766V11.9834V11.8901L1.37294 0.328964Z"
                fill="url(#paint0_linear_5749_1891)"
            />
            <path
                d="M16.8508 15.9924L13.0282 12.1698V11.9833V11.8901L16.8508 8.06741L16.9441 8.16065L21.5126 10.7712C22.8179 11.5171 22.8179 12.7292 21.5126 13.4751L16.8508 15.9924Z"
                fill="url(#paint1_linear_5749_1891)"
            />
            <path
                d="M16.9438 15.8992L13.0279 11.9833L1.37354 23.6377C1.83971 24.1039 2.49236 24.1039 3.33147 23.731L16.9438 15.8992Z"
                fill="url(#paint2_linear_5749_1891)"
            />
            <path
                d="M16.9438 8.06752L3.33147 0.328994C2.49236 -0.137181 1.83971 -0.0439464 1.37354 0.42223L13.0279 11.9834L16.9438 8.06752Z"
                fill="url(#paint3_linear_5749_1891)"
            />
            <path
                opacity="0.2"
                d="M16.8505 15.806L3.33147 23.4513C2.58559 23.9175 1.93295 23.8243 1.46677 23.4513L1.37354 23.5446L1.46677 23.6378C1.93295 24.0107 2.58559 24.104 3.33147 23.6378L16.8505 15.806Z"
                fill="black"
            />
            <path
                opacity="0.12"
                d="M1.37294 23.4514C1.09323 23.1716 1 22.7055 1 22.1461V22.2393C1 22.7987 1.18647 23.2649 1.46618 23.5446V23.4514H1.37294Z"
                fill="black"
            />
            <path
                opacity="0.12"
                d="M21.5129 13.1954L16.8512 15.806L16.9444 15.8992L21.5129 13.2886C22.1656 12.9157 22.4453 12.4495 22.4453 11.9833C22.4453 12.4495 22.0724 12.8225 21.5129 13.1954Z"
                fill="black"
            />
            <path
                opacity="0.25"
                d="M3.33088 0.422178L21.5117 10.7713C22.0711 11.1442 22.4441 11.5172 22.4441 11.9833C22.4441 11.5172 22.1644 11.051 21.5117 10.6781L3.33088 0.328943C2.02559 -0.416939 1 0.142472 1 1.63423V1.72747C1 0.328943 2.02559 -0.323704 3.33088 0.422178Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_5749_1891"
                    x1="12.0014"
                    y1="1.45692"
                    x2="-3.64575"
                    y2="17.104"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00A0FF" />
                    <stop
                        offset="0.00657445"
                        stopColor="#00A1FF"
                    />
                    <stop
                        offset="0.2601"
                        stopColor="#00BEFF"
                    />
                    <stop
                        offset="0.5122"
                        stopColor="#00D2FF"
                    />
                    <stop
                        offset="0.7604"
                        stopColor="#00DFFF"
                    />
                    <stop
                        offset="1"
                        stopColor="#00E3FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_5749_1891"
                    x1="23.2228"
                    y1="11.9847"
                    x2="0.662813"
                    y2="11.9847"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFE000" />
                    <stop
                        offset="0.4087"
                        stopColor="#FFBD00"
                    />
                    <stop
                        offset="0.7754"
                        stopColor="#FFA500"
                    />
                    <stop
                        offset="1"
                        stopColor="#FF9C00"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_5749_1891"
                    x1="14.8245"
                    y1="14.1242"
                    x2="-6.39428"
                    y2="35.3429"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF3A44" />
                    <stop
                        offset="1"
                        stopColor="#C31162"
                    />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_5749_1891"
                    x1="-1.51936"
                    y1="-6.49927"
                    x2="7.95576"
                    y2="2.97574"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A071" />
                    <stop
                        offset="0.0685"
                        stopColor="#2DA771"
                    />
                    <stop
                        offset="0.4762"
                        stopColor="#15CF74"
                    />
                    <stop
                        offset="0.8009"
                        stopColor="#06E775"
                    />
                    <stop
                        offset="1"
                        stopColor="#00F076"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
}
